var APP = APP || {};
var app = angular.module('siteApp', ['userController']);